import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AuthenticationService } from '../service/auth.service';
import { Router, NavigationExtras } from "@angular/router";

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  private extras: NavigationExtras | undefined;
  constructor(private authenticationService: AuthenticationService, private router: Router) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(catchError(err => {
      const errorMessage = err.error.detail;
      this.extras = {
        state: {
          error: errorMessage
        }
      };
      return throwError(errorMessage);
    }));
  }
}
